import { EventRepository } from '../repositories/EventRepository';
import serviceNames from '../../service-setup/AnalyticsService';
import { diContainer } from '../../service-setup/diContainer';
import { Event } from '../domain/entities/Event';
import { events } from '@estee/elc-service-bus';
import { IProductViewed } from '../interfaces/IAnalytics';

export class ShadeChangeViewedUseCase {
    private eventRepository: EventRepository;
    private shadeChangeActionPayload: IProductViewed;
    constructor(shadeChangeActionPayload: IProductViewed) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.shadeChangeActionPayload = shadeChangeActionPayload;
    }

    public execute = () => {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.PRODUCT_SKU_SELECTED,
            type: 'link',
            payload: {
                event_name: 'product_detail_shade_size',
                enh_action: 'detail',
                event_category: 'ecommerce',
                event_action: 'spp',
                event_noninteraction: true,
                event_label: 'shade size switch'
            },
            data: {
                product: this.shadeChangeActionPayload
            }
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
